/**
 * Relationships Routes
 * ============================================================================
 *
 * Tenant-side broker ↔ insurer relationship pages. Both list and detail
 * are mounted under the same dashboard layout as the rest of the tenant
 * portal. No role-based gate here — service-layer guards enforce
 * businessType per endpoint, and the pages render a "not applicable"
 * empty state for tenant types that aren't BROKER or INSURER.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const RelationshipsListPage = lazy(
  () => import('@/features/relationships/ui/pages/relationships-list-page')
);
const RelationshipDetailPage = lazy(
  () => import('@/features/relationships/ui/pages/relationship-detail-page')
);

export const relationshipsRoutes: RouteGroup = {
  name: 'relationships',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.RELATIONSHIPS,
      component: RelationshipsListPage,
      meta: {
        title: 'settings:relationships.pageTitleBroker',
        showInNav: true,
      },
    },
    {
      path: ROUTE_PATHS.RELATIONSHIP_DETAIL,
      component: RelationshipDetailPage,
      meta: {
        title: 'settings:relationships.detailTitle',
        parent: ROUTE_PATHS.RELATIONSHIPS,
      },
    },
  ],
};
